import React from "react";

const ROOMS = ["general", "tech", "games"];

function Sidebar({ isSidebarOpen, setIsSidebarOpen, selected, username, onlineUsers, selectRoom, selectUser }) {
    return (
        <div
            className={`fixed inset-y-0 left-0 w-64 bg-gray-900 p-6 border-r border-gray-700 space-y-6 transform transition-transform duration-300 z-50 ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"
                } lg:translate-x-0 lg:static lg:w-1/4`}
        >
            <div className="flex justify-between items-center mb-4 lg:hidden">
                <h2 className="text-lg font-bold">Menu</h2>
                <button onClick={() => setIsSidebarOpen(false)}>
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                </button>
            </div>

            <div>
                <h3 className="font-bold mb-2 text-white">Rooms</h3>
                {ROOMS.map((room) => (
                    <div
                        key={room}
                        onClick={() => selectRoom(room)}
                        className={`p-3 rounded cursor-pointer ${selected.name === room && selected.type === "room"
                            ? "bg-white text-black font-semibold"
                            : "hover:bg-gray-700"
                            }`}
                    >
                        #{room}
                    </div>
                ))}
            </div>

            <div>
                <h3 className="font-bold mb-2 text-white">DMs</h3>
                {onlineUsers
                    .filter((u) => u !== username)
                    .map((user) => (
                        <div
                            key={user}
                            onClick={() => selectUser(user)}
                            className={`p-3 rounded cursor-pointer ${selected.name === user && selected.type === "dm"
                                ? "bg-white text-black font-semibold"
                                : "hover:bg-gray-700"
                                }`}
                        >
                            {user}
                        </div>
                    ))}
            </div>
        </div>
    );
}

export default Sidebar;


